let tiles = [];

let numCuts = 12;
let numBars = 12;

let bars = new Array(numBars);
let cuts = new Array(numBars);

let easing = 0.025;

let NOISESTEP = 0.1;
let MOVESTEP = 0.005;
let noiseX = 0;
let noiseY = 0;

let currentImage = 0;
let sources = new Array(4);

window.preload = function(){

    sources[0] = loadImage('assets/images/demo1-main.jpg');
    sources[1] = loadImage('assets/images/as.png');
    sources[2] = loadImage('assets/images/cities.png');
    sources[3] = loadImage('assets/images/ie.png');
}

window.setup = function() {

    var canvas = createCanvas(windowWidth, windowHeight, WEBGL);
    canvas.parent('noisegrid-container');


    noStroke();
    textureMode(NORMAL);

    for(let i = 0; i < bars.length; i++){
		bars[i] = (i+1)*(height/bars.length);
		cuts[i] = new Array(numCuts);
		for(let j = 0; j < numCuts; j++){
			cuts[i][j] = (j+1) * (width/numCuts);
		}
	}

    for (let bi = 0; bi < bars.length; bi++) {
        for (let ci = 0; ci < cuts[bi].length; ci++) {
        	tiles.push(new Tile(bi, ci));
        }
	}

}

window.windowResized = function() {
    resizeCanvas(windowWidth, windowHeight);
}

window.draw = function() {
    background(255, 0, 255);

    if(mouseX < width/2 && mouseY < height/2){
        currentImage = 0;
    } else if (mouseX >= width/2 && mouseY < height/2){
        currentImage = 1;
    } else if (mouseX < width/2 && mouseY >= height/2){
        currentImage = 2;
    } else if (mouseX >= width/2 && mouseY >= height/2){
        currentImage = 3;
    }

    console.log(currentImage);

    push();
    translate(-width/2, -height/2)

    getBarPositions();
    getCutPositions();

    for(let i = 0; i < tiles.length; i++){
        tiles[i].update();
        tiles[i].display();
    }

    noiseX+=MOVESTEP;

    pop();

}

function getBarPositions() {

    let noiseValues = new Array(numBars);

    let min =  1;
    let max = 0;

	let noiseTotal = 0;

    for (let i = 0; i < bars.length; i++) {
	  noiseValues[i] = noise(noiseX, noiseY+NOISESTEP*i);

      if (noiseValues[i] < min) {
        min = noiseValues[i];
      }
      if (noiseValues[i] > max) {
        max = noiseValues[i];
      }

      //noiseTotal += noiseValues[i];
    }

    for (let i = 0; i < bars.length; i++) {
      if (!smooth) {
        noiseValues[i] = map(noiseValues[i], min, max, 0.25, .75);
      }
      noiseTotal +=  noiseValues[i];
	}

    let _y = 0;

    for (let i = 0; i < noiseValues.length-1; i++) {
	  _y += map(noiseValues[i], 0, noiseTotal, 0, height);
	  let _sy = _y - bars[i];
      bars[i] += _sy*easing;
	}


}

function getCutPositions() {

    for (let i = 0; i < bars.length; i++) {

      let min =  1;
      let max = 0;

      let noiseValues = new Array(numCuts);

      let noiseTotal = 0;
      for (let j = 0; j < cuts[i].length; j++) {
        noiseValues[j] = noise(noiseX+NOISESTEP*j, noiseY+NOISESTEP*i);
        if (noiseValues[j] < min) {
          min = noiseValues[j];
        }
        if (noiseValues[j] > max) {
          max = noiseValues[j];
        }
        //noiseTotal += noiseValues[j];
      }


      for (let j = 0; j < cuts[i].length; j++) {
        if (!smooth) {
          noiseValues[j] = map(noiseValues[j], min, max, 0.25, .75);
        }
        noiseTotal +=  noiseValues[j];
	  }



      let _x = 0;

      for (let j = 0; j < noiseValues.length-1; j++) {
        _x += map(noiseValues[j], 0, noiseTotal, 0, width);
        let _sx = _x - cuts[i][j];
        cuts[i][j] += _sx*easing;
      }
    }
  }


  class Tile {

    constructor(_bid, _cid){

        this.x = 0;
        this.y = 0;
        this.w = 0
        this.h = 0;
        this.barId = _bid;
        this.colId = _cid;
        this.c = color(random(255));
        this.ratio;
		this.alive = true;

		this.txtrImage = sources[currentImage];
		this.ratio = this.txtrImage.width/this.txtrImage.height;

        if(this.barId == 0 || this.colId == 0 || this.barId == numBars-1 || this.colId == numBars-1){
            this.alive = false;
        }
    }

    update(){
      if(this.barId == 0){
        this.y = 0;
      } else {
        this.y = bars[this.barId-1];
      }


      if(this.barId == numBars-1){
        this.h = height-this.y;
      } else {
        this.h = bars[this.barId]-this.y;
      }

      if(this.colId == 0){
         this.x  = 0;
      }  else  {
        this.x = cuts[this.barId][this.colId-1];
      }


      if(this.colId == numCuts-1){
        this.w = width-this.x;
      } else {
        this.w = cuts[this.barId][this.colId]-this.x;
      }

      this.w+=1;
      this.h+=1;

      this.txtrImage = sources[currentImage];

    }


    drawImage(rx, ry, rw, rh){

    fill(255, 214, 0);
    let r = rw/rh;

    if(r >= this.ratio){
        let wr = rw/this.txtrImage.width;
        let nh = wr*this.txtrImage.height;
        let t = abs(nh-rh)/2;

        let txtrm = t/nh;

        beginShape();
        if(this.alive){
            texture(this.txtrImage);
        }
        vertex(rx, ry, 0, txtrm);
        vertex(rx+rw, ry, 1, txtrm);
        vertex(rx+rw, ry+rh, 1, 1-txtrm);
        vertex(rx, ry+rh, 0, 1-txtrm);
        endShape();
    } else {
        let hr = rh/this.txtrImage.height;
        let nw = hr*this.txtrImage.width;
        let t = abs(rw-nw)/2;
        let txtrm = t/nw;

        beginShape();
        if(this.alive){
            texture(this.txtrImage);
        }
        vertex(rx, ry, txtrm, 0);
        vertex(rx+rw, ry, 1-txtrm, 0);
        vertex(rx+rw, ry+rh, 1-txtrm, 1);
        vertex(rx, ry+rh, txtrm, 1);
        endShape();
      }
    }




    display(){
        fill(this.c);
        this.drawImage(this.x, this.y, this.w, this.h);

    }

  }


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/EXT/snaders/frontend/source/utilities/noisegrid.js